/* global femcare, Swiper */

/**
 * Banner module for initializing the swiper slider and repositioning the product rating.
 */
femcare.banner = {
    bannerElement: document.querySelector('.banner'),

    /**
     * Initializes the banner slider and other functionalities if the banner exists.
     */
    init() {
        if (this.bannerElement) {
            this.initSlider();
            this.repositionPowerReviewRating();
        }
    },

    /**
     * Initializes the Swiper slider with autoplay functionality.
     */
    initSlider() {
        new Swiper(this.bannerElement, {
            slidesPerView: 1,
            spaceBetween: 50,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });
    },

    // TODO: Review why this code is in this file when refactoring PWR - should be removed!!
    repositionPowerReviewRating() {
        const productRatingElement = document.querySelector('.product-main__rating');
        if (productRatingElement) {
            productRatingElement.style.top = '135px';
        }
    }
};
